import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { useObservable } from '~/@components/@hooks/use-observable';
import { COLORS } from '~/@components/@theme/colors';
import { Chip } from '~/@components/Chip';
import { removeEmptyKeys } from '~/@store/common';
import { companiesStore, CompaniesStoreFilter, CompaniesStoreFilterFields } from '~/@store/companies/companies.store';
import { formatFilterValue } from '~/@views/AdminView/common/utils';
import i18n from '~/i18n';

const FieldNames: CompaniesStoreFilter = {
    [CompaniesStoreFilterFields.name]: i18n.CompaniesTable.companyName,
    [CompaniesStoreFilterFields.organizationNumber]: i18n.CompaniesTable.orgNumber,
    [CompaniesStoreFilterFields.phone]: i18n.CompaniesTable.phone,
    [CompaniesStoreFilterFields.email]: i18n.CompaniesTable.email,
    [CompaniesStoreFilterFields.GLN]: i18n.CompaniesTable.GLN,
};

export const CompaniesFilterSummary = () => {
    const filterValues = useObservable(() => removeEmptyKeys({ ...companiesStore.filter.values }));

    const { root, chip } = useStyles();

    return (
        <div className={root}>
            {Object.keys(filterValues).map(objectKey => {
                const key = objectKey as CompaniesStoreFilterFields;
                const value = filterValues[key];
                if (value === null || value === undefined) return null;
                const chipContent = `${FieldNames[key]}: "${formatFilterValue(value)}"`;

                return (
                    <Chip
                        key={key}
                        className={chip}
                        color={COLORS.black}
                        onDelete={() => companiesStore.filter.setValue(key, null)}
                        deleteIcon={<Icon>close</Icon>}>
                        {chipContent}
                    </Chip>
                );
            })}
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
    },
    chip: {
        marginRight: theme.spacing(1),
    },
}));
